import React from "react";
import { Line } from "react-chartjs-2";
import { fCurrency, fNumber } from '../../../../utils/formatNumber';

const LineChart = ({ chartData }) => {
  var options = {
    plugins: {
      title: {
        display: true,
      },
    },
    responsive: true,
    offsetGridLines: true,
    drawTicks: true,
    legend: {
      display: true,
      position: "top",
      align: "center",
      labels: {
        usePointStyle: true,
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            callback: function (label, index, labels) {
              //return label / 1000 + "k";
             return fNumber(label);
            },
          },
          scaleLabel: {
            display: true,
            //labelString: "1k = 1000",
          },
        },
      ],
    },
    // tooltips: {
    //   displayColors: false,
    //   titleFontSize: 12,
    //   bodyFontSize: 14,
    //   xPadding: 10,
    //   yPadding: 10,
    //   callbacks: {
    //     label: (tooltipItem, data) => {
    //       return `$ ${tooltipItem.value} `;
    //     },
    //   },
    // },
  };
 

  return (
    <div>
      <Line data={chartData} options={options} />
    </div>
  );
};
export default LineChart;
